module.exports = __webpack_public_path__ + "media/images/advisor/img_2_0-dd78586c294f5ae4c33dcda853596d92.png";